import USER_API from 'api/user/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import {
  ACCOUNTS_CONNECTED_FETCH_START,
  SET_ACCOUNTS_CONNECTED,
  ACCOUNTS_CONNECTED_FETCH_FAIL,
  ACCOUNTS_CONNECTED_FETCH_END,
  DELETE_ACCOUNT_FETCH_START,
  DELETE_ACCOUNT_FETCH_FAIL,
  DELETE_ACCOUNT_FETCH_END,
  GET_USER_ACCOUNTS_CONNECTED,
  DELETE_USER_ACCOUNT
} from './types'

function* getAccounts() {
  return yield call(USER_API.fetchAll)
}

function* deleteAccount() {
  return yield call(USER_API.deleteAdmitadAccount)
}

function* getUserAccountsConnected() {
  try {
    yield put({
      type: ACCOUNTS_CONNECTED_FETCH_START,
      payload: 'user/accounts',
    })
    const { response, error } = yield call(getAccounts)

    if (error) {
      throw error
    }

    yield put({
      type: SET_ACCOUNTS_CONNECTED,
      payload: response.data,
    })
  } catch (error) {
    yield put({
      type: ACCOUNTS_CONNECTED_FETCH_FAIL,
      payload: 'user/accounts',
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: ACCOUNTS_CONNECTED_FETCH_END,
      payload: 'user/accounts',
    })
  }
}

function* deleteUserAccount() {
  try {
    yield put({
      type: DELETE_ACCOUNT_FETCH_START,
      payload: 'user/accounts',
    })
    const { error } = yield call(deleteAccount)

    if (error) {
      throw error
    }

    yield put({
      type: SET_ACCOUNTS_CONNECTED,
      payload: {},
    })
  } catch (error) {
    yield put({
      type: DELETE_ACCOUNT_FETCH_FAIL,
      payload: 'user/accounts',
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: DELETE_ACCOUNT_FETCH_END,
      payload: 'user/accounts',
    })
  }
}

export default function* Sagas() {
  yield takeLatest(GET_USER_ACCOUNTS_CONNECTED, getUserAccountsConnected)
  yield takeLatest(DELETE_USER_ACCOUNT, deleteUserAccount)
}
